import { ApolloError } from "@apollo/client";
import { IntlShape, MessageDescriptor } from "react-intl";
import { GraphQLErrors } from "@apollo/client/errors";

import { UNKNOWN_ERROR, defaultMessages } from "./consts";

export const intlApolloError = (
  intl: IntlShape,
  messages: Record<string, string | MessageDescriptor>,
  error?: ApolloError
): ApolloError | undefined => {
  if (!error) {
    return undefined;
  }

  const messageDescriptors: typeof messages = {
    ...defaultMessages,
    ...messages,
  };

  const graphQLErrors = error.graphQLErrors.reduce<GraphQLErrors>(
    (reduced, graphQLError) => {
      const { errorInfo, errorType } = graphQLError || {};

      if (!errorType) {
        return reduced;
      }

      const { path = "", type = "" } = errorInfo || {};
      const field = path.split(".").slice(-1).pop();
      const messageDescriptor =
        messageDescriptors[`${path}/${type}`] ||
        messageDescriptors[`${path}/${errorType}`] ||
        messageDescriptors[`${field}/${type}`] ||
        messageDescriptors[`${field}/${errorType}`] ||
        messageDescriptors[path] ||
        messageDescriptors[type] ||
        messageDescriptors[errorType];

      if (!messageDescriptor) {
        return [...reduced, graphQLError];
      }

      const message =
        typeof messageDescriptor === "string"
          ? messageDescriptor
          : intl.formatMessage(messageDescriptor);
      const localizedError: GraphQLErrors[number] = Object.assign(
        graphQLError,
        { message }
      );

      return [...reduced, localizedError];
    },
    []
  );

  const firstMessage = graphQLErrors[0]?.message;
  const unknownMessage =
    typeof messageDescriptors[UNKNOWN_ERROR] === "string"
      ? messageDescriptors[UNKNOWN_ERROR]
      : intl.formatMessage(messageDescriptors[UNKNOWN_ERROR]);

  return new ApolloError({
    ...error,
    graphQLErrors,
    errorMessage: firstMessage ?? unknownMessage,
  });
};
